
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import cx from 'classnames';
import { connect } from '../../../../../../redux/connect';
import { updateIssueAction, setIsShowingPushpinVisibilityPopUp, setIsShowingDeletePushpinPopUp, trackEvent } from '../../../../../../redux/actions';
import { getCurrentViewType, getDocumentCollection, isChangingPushpinVisibility, getIsUserCanEditRfiDocument, isDeletingPushpin, currentUserRoleForAnalytics } from '../../../../../../redux/selectors';
import { issueAttributesType, documentCollectionType } from '../../../../../../constants/proptype-validation';
import { Label } from '@adsk/bim360-matrix-react-components';
import { viewTypes } from '../../../../../../constants/view-types';
import { actions as pushpinActions } from '../../../../../../constants/pushpin-visibility';
import featureFlags, { FEATURE_FLAGS } from '../../../../../../utils/featureFlags';
import DocumentDescription from './components/DocumentDescription';
import AddDocumentButton from '../../../../../AddDocumentButton';
import DocumentPicker from '../../../../../DocumentPicker';
import { fieldEdit } from '../../../../../../utils/analytics-helpers';
import { ISSUE_ATTRIBUTE_NAMES } from '../../../../../../constants/issue-attribute-names';

class LinkedDocumentInlineEdit extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      updatingDocument: null,
    };

    this.handleDocumentAction = this.handleDocumentAction.bind(this);
    this.onUpdateError = this.onUpdateError.bind(this);
    this.onUpdateSuccess = this.onUpdateSuccess.bind(this);
    this.updatePushpin = this.updatePushpin.bind(this);

  }

  getDocument() {
    const { issue: { targetUrn }, documentCollection } = this.props;
    return this.state.updatingDocument || documentCollection[targetUrn];
  }

  onUpdateError() {
    this.setState({ updatingDocument: null });
  }

  onUpdateSuccess() {
    this.setState({ updatingDocument: null });
    const { issue, trackEvent, userRoleForAnalytics } = this.props;
    trackEvent(fieldEdit(ISSUE_ATTRIBUTE_NAMES.LINKED_DOCUMENT, issue.status, userRoleForAnalytics));
  }

  updatePushpin(document, pushpin, sheetMetadata) {
    const { issue, updateIssueAction } = this.props;

    const targetUrn = document.urn;
    const startingVersion = document.latestVersion;
    const objectId = pushpin.objectId && pushpin.objectId.toString();
    const pushpinAttributes = {
      type: pushpin.position.z ? 'TwoDVectorPushpin' : 'TwoDRasterPushpin',
      location: pushpin.position,
      objectId,
      viewerState: pushpin.viewerState,
      externalId: pushpin.externalId,
      attributesVersion: pushpin.attributesVersion,
    };

    updateIssueAction(issue, { targetUrn, startingVersion, pushpinAttributes, sheetMetadata }, { onError: this.onUpdateError, onSuccess: this.onUpdateSuccess });
    this.setState({ updatingDocument: document });
  }

  handleDocumentAction(actionKey) {
    const { issue, setIsShowingPushpinVisibilityPopUp, setIsShowingDeletePushpinPopUp } = this.props;
    switch (actionKey) {
      case pushpinActions.SHOW:
      case pushpinActions.HIDE:
        setIsShowingPushpinVisibilityPopUp(!!issue);
        break;
      case pushpinActions.DELETE:
        setIsShowingDeletePushpinPopUp(!!issue);
        break;
      default:
        break;
    }
  }

  render() {
    const { container, issue, className, horizontalAlign, viewType, isChangingPushpinVisibility, isDeletingPushpin, isUserCanEditRfiDocument } = this.props;

    const document = this.getDocument();
    const showDocumentName = document && !isDeletingPushpin;

    const { status, startingVersion } = issue;
    const classes = cx('LinkedDocumentInlineEdit', className, horizontalAlign ? `LinkedDocumentInlineEdit--horizontal` : '');

    const isProjectView = viewType === viewTypes.PROJECT;
    const allowLink = isProjectView;
    const issueStartingVersion = document && document.latestVersion ? document.latestVersion : startingVersion;

    const showEditPushpin = featureFlags.get(FEATURE_FLAGS.EDIT_LINK_TO_DOCUMENT) && isUserCanEditRfiDocument;
    const documentDescriptionProps = { issue, allowLink, issueStartingVersion, document, container, isChangingPushpinVisibility, isDeletingPushpin, handleDocumentAction: this.handleDocumentAction };

    return <div className={classes}>
      <div className="LinkedDocumentInlineEdit__label">
        <Label>{T.translate('issueAttributes.document.label')}</Label>
      </div>
      {
        showEditPushpin ?
          <DocumentPicker container={container} onSelectDocumentPushpin={this.updatePushpin} status={status}>
            {(startDocumentSelection) => {
              return (
                <div className="LinkToDocumentField">
                  {showDocumentName ?
                    <DocumentDescription
                      {...{ ...documentDescriptionProps, canDeletePushpin: true }}
                    />
                    : isProjectView ?
                      <AddDocumentButton onClick={startDocumentSelection} /> :
                      <DocumentDescription {...documentDescriptionProps} />
                  }
                </div>
              );
            }}
          </DocumentPicker> :
          <DocumentDescription {...documentDescriptionProps} />

      }
    </div>;
  }
}

LinkedDocumentInlineEdit.displayName = 'LinkedDocumentInlineEdit';

LinkedDocumentInlineEdit.propTypes = {
  issue: issueAttributesType.isRequired,
  documentCollection: documentCollectionType,
  viewType: PropTypes.string.isRequired,
  container: PropTypes.object.isRequired,
  updateIssueAction: PropTypes.func.isRequired,
  className: PropTypes.string,
  setIsShowingPushpinVisibilityPopUp: PropTypes.func.isRequired,
  setIsShowingDeletePushpinPopUp: PropTypes.func.isRequired,
  isChangingPushpinVisibility: PropTypes.bool.isRequired,
  isDeletingPushpin: PropTypes.bool.isRequired,
  horizontalAlign: PropTypes.bool,
  isUserCanEditRfiDocument: PropTypes.bool.isRequired,
  trackEvent: PropTypes.func.isRequired,
  fieldEdit: PropTypes.func.isRequired,
  userRoleForAnalytics: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    viewType: getCurrentViewType(state),
    documentCollection: getDocumentCollection(state),
    isChangingPushpinVisibility: isChangingPushpinVisibility(state),
    isUserCanEditRfiDocument: getIsUserCanEditRfiDocument(state),
    isDeletingPushpin: isDeletingPushpin(state),
    userRoleForAnalytics: currentUserRoleForAnalytics(state),
  };
};

export default connect(mapStateToProps, {
  updateIssueAction,
  setIsShowingPushpinVisibilityPopUp,
  setIsShowingDeletePushpinPopUp,
  trackEvent,
})(LinkedDocumentInlineEdit);
